import { get as lodashGet } from 'lodash'
import sortBy from 'lodash/sortBy'
import moment from 'utils/momentInstanse'

export const simpleFacilityMapper = (response) => {
  if (!response?.data?.body?.group || !response?.data?.body?.city) {
    return null
  }

  const { name, current_temperature, image_uri, group, city } =
    response.data.body

  return {
    nameFacility: name && typeof name === 'string' ? name : '',
    currentTemperatureFacility:
      typeof current_temperature === 'number'
        ? current_temperature.toFixed(1)
        : '',
    imageUrlFacility: image_uri || '',
    groupFacilityName: lodashGet(group, 'name', ''),
    groupFacilityImageUrl: lodashGet(group, 'image_uri', ''),
    cityFacility: lodashGet(city, 'name', ''),
  }
}

export const heatmapMapper = (data = []) => {
  if (!data.length) return null

  const hoursOfDay = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    21, 22, 23,
  ]

  const sortData = sortBy(data, [
    (i) => {
      return moment.unix(i.timestamp).hour()
    },
    (i) => {
      return moment.unix(i.timestamp).isoWeekday()
    },
  ])

  const res = hoursOfDay.reverse().reduce((result, item) => {
    const resultItem = sortData.reduce(
      (resItem, dataItem) => {
        if (moment.unix(dataItem.timestamp).hour() === item) {
          resItem.data.push(dataItem.ratio)
          resItem.currentData.push(dataItem.current)
          resItem.name = moment.unix(dataItem.timestamp).format('HH:mm')
          resItem.itemData.push({
            ...dataItem,
            date: moment.unix(dataItem.timestamp).format(),
          })
        }
        return resItem
      },
      {
        name: '',
        data: [],
        currentData: [],
        itemData: [],
      }
    )

    result.push(resultItem)

    return result
  }, [])

  return res
}
